var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"MainContacts-View"},[_c('SpaceDescription',[_c('Headline',{attrs:{"size":1}},[_vm._v("List of teams")])],1),_c('TeamsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }